export const API_CALL_STATUS = {
	SUCCEEDED: 1,
	LOADING: 2,
	FAILED: 3,
	IDLE: 4
}

export const WORK_ORDER_STATUSES = {
	NEW: "New",
	ENGAGING: "Engaging",
	IGNORED: "Ignored"
}

export const URGENCY_OPTIONS = ['critical', 'minor', 'normal']

export const WORK_ORDER_TYPE_OPTIONS = ['Turn', 'Maintenance', 'Renovation', 'Unknown']
export const WORK_ORDER_STATUS_OPTIONS = ['assigned', 'closed', 'on_hold', 'resolved', 'scheduled', 'seen']
export const PROPERTY_CATEGORY_OPTIONS = ['apartment', 'commercial', 'condominium', 'manufactured', 'mixeduse', 'multifamily', 'parking', 'singlefamily', 'townhouse']
export const PROPERTY_STATUS_OPTIONS = [
	'approved_applicant',
	'assumption_occupied',
	'assumption_prep',
	'first_possession_inspection_or_initial_renovation',
	'listed_for_rent',
	'listed_for_sale',
	'long_term_renovation',
	'marketing_issue',
	'occupied',
	'on_notice',
	'pending_move_in',
	'under_contract_for_purchase',
	'unit_turn',
	'vacant_no_turn',
	'with_marketing'
]

export const STATES = [
	"AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
	"HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
	"MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
	"NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
	"SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];
